<template>
	<div
		class="center justify-center rounded-circle"
		:style="{ width: tamanho, height: tamanho, backgroundColor: corBackground }"
		v-on="$listeners"
	>
		<span :style="{ color: corLabel, fontSize: tamanhoFonte }">{{ label }}</span>
	</div>
</template>

<script>
export default {
	name: 'chip-round',
	props: {
		label: {
			type: String,
			default: '',
		},
		corLabel: {
			type: String,
			default: 'black',
		},
		corBackground: {
			type: String,
			default: '#D0D0D0',
		},
		tamanho: {
			type: String,
			default: '22px',
		},
		tamanhoFonte: {
			type: String,
			default: '12px',
		},
	},
}
</script>

<style scoped>
.rounded-circle {
    text-align: center;
    z-index: 2;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 20px !important;
    width: 20px !important;
}
</style>
